export enum UIPAGE {
	ADMINISTRATION = "/UI/PAGE/administration",
	ADMINISTRATION_B2B_SEGMENTS = "/UI/PAGE/administration/b2b-segments",
	ADMINISTRATION_BLACKLIST = "/UI/PAGE/administration/blacklist",
	ADMINISTRATION_BULK = "/UI/PAGE/administration/bulk",
	ADMINISTRATION_CACHE = "/UI/PAGE/administration/cache",
	ADMINISTRATION_CHANNELS = "/UI/PAGE/administration/channels",
	ADMINISTRATION_DEPENDENCIES = "/UI/PAGE/administration/dependencies",
	ADMINISTRATION_DIGITAL_CONTRACT = "/UI/PAGE/administration/digital-contract",
	ADMINISTRATION_DROPDOWNS = "/UI/PAGE/administration/dropdowns",
	ADMINISTRATION_OTHERS = "/UI/PAGE/administration/others",
	ADMINISTRATION_PRODUCTS_DEPENDENCIES = "/UI/PAGE/administration/products-dependencies",
	ADMINISTRATION_PRODUCTS_MANDATORY_DOCUMENTS = "/UI/PAGE/administration/products-mandatory-documents",
	ADMINISTRATION_PROMOTION_GROUPS = "/UI/PAGE/administration/promotion-groups",
	ADMINISTRATION_RETAIL_EXCLUSIVITY_RULES = "/UI/PAGE/administration/retail-exclusivity-rules",
	ADMINISTRATION_TRANSITION_CONFIGURATION = "/UI/PAGE/administration/products-transition",
	ADMINISTRATION_USERS = "/UI/PAGE/administration/users",
	APPROVAL_DETAIL = "/UI/PAGE/approvals/:id",
	APPROVALS = "/UI/PAGE/approvals",
	COVERAGE_SEARCH = "/UI/PAGE/coverage-search",
	CUSTOMER_360 = "/UI/PAGE/customer",
	CUSTOMER_360_AGGRUPATIONS = "/UI/PAGE/customer/aggrupations",
	CUSTOMER_360_CHARGES_CREDITS = "/UI/PAGE/customer/charges-credits",
	CUSTOMER_360_DOCUMENTS = "/UI/PAGE/customer/documents",
	CUSTOMER_360_BILLING = "/UI/PAGE/customer/billing",
	CUSTOMER_360_FINANCES = "/UI/PAGE/customer/finances",
	CUSTOMER_360_FOLLOW_UP = "/UI/PAGE/customer/follow-up",
	CUSTOMER_360_GRUPO_AIRE_WORK_TASKS = "/UI/PAGE/customer/grupo-aire-work-tasks",
	CUSTOMER_360_HANDOVER = "/UI/PAGE/customer/handover",
	CUSTOMER_360_HANDOVER_RESEGMENTATION = "/UI/PAGE/customer/handover/resegmentations",
	CUSTOMER_360_JIRA_TICKETS = "/UI/PAGE/customer/jira-tickets",
	CUSTOMER_360_NOTES = "/UI/PAGE/customer/notes",
	CUSTOMER_360_ORDERS = "/UI/PAGE/customer/orders",
	CUSTOMER_360_PRODUCTS = "/UI/PAGE/customer/products",
	CUSTOMER_360_TASKS = "/UI/PAGE/customer/tasks",
	CUSTOMER_360_WORK_TASKS = "/UI/PAGE/customer/work-tasks",
	CUSTOMER_NEW_EXTRAS = "/UI/PAGE/customer/new-extras",
	CUSTOMER_NEW_EXTRAS_BUNDLE = "/UI/PAGE/customer/new-extras/bundle",
	CUSTOMER_NEW_EXTRAS_CONFIGURATION = "/UI/PAGE/customer/new-extras/configuration",
	CUSTOMER_NEW_EXTRAS_ID_BUNDLE = "/UI/PAGE/customer/new-extras/:newExtrasId/bundle",
	CUSTOMER_NEW_EXTRAS_ORDER = "/UI/PAGE/customer/new-extras/order",
	CUSTOMER_NEW_EXTRAS_PROMOTIONS = "/UI/PAGE/customer/new-extras/promotions",
	CUSTOMER_PRODUCT_USAGE_DATA = "/UI/PAGE/customer/product/usage-data",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS = "/UI/PAGE/customer/product/change-of-address",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE = "/UI/PAGE/customer/product/continue-change-of-address/",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_CONFIGURATION = "/UI/PAGE/customer/product/continue-change-of-address/:processId/configuration",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_ORDER = "/UI/PAGE/customer/product/continue-change-of-address/:processId/order",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_2ND_PHASE_PROMOTIONS = "/UI/PAGE/customer/product/continue-change-of-address/:processId/promotions",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_ID_COVERAGE = "/UI/PAGE/customer/product/change-of-address/:processId/coverage",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_ID_INTERMEDIATE_CONFIGURATION = "/UI/PAGE/customer/product/change-of-address/:processId/intermediate-configuration",
	CUSTOMER_PRODUCT_CHANGE_OF_ADDRESS_ID_INTERMEDIATE_ORDER = "/UI/PAGE/customer/product/change-of-address/:processId/intermediate-order",
	CUSTOMER_PRODUCT_MODIFICATION = "/UI/PAGE/customer/product/modification",
	CUSTOMER_PRODUCT_MODIFICATION_BUNDLE = "/UI/PAGE/customer/product/modification/bundle",
	CUSTOMER_PRODUCT_MODIFICATION_CONFIGURATION = "/UI/PAGE/customer/product/modification/configuration",
	CUSTOMER_PRODUCT_MODIFICATION_ID_BUNDLE = "/UI/PAGE/customer/product/modification/:modificationId/bundle",
	CUSTOMER_PRODUCT_MODIFICATION_ORDER = "/UI/PAGE/customer/product/modification/order",
	CUSTOMER_PRODUCT_MODIFICATION_PROMOTIONS = "/UI/PAGE/customer/product/modification/promotions",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION = "/UI/PAGE/customer/product/only-mobiles-transition",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION_BUNDLE = "/UI/PAGE/customer/product/only-mobiles-transition/bundle",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION_CONFIGURATION = "/UI/PAGE/customer/product/only-mobiles-transition/configuration",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION_ID_BUNDLE = "/UI/PAGE/customer/product/only-mobiles-transition/:transitionId/bundle",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION_ORDER = "/UI/PAGE/customer/product/only-mobiles-transition/order",
	CUSTOMER_PRODUCT_ONLY_MOBILES_TRANSITION_PROMOTIONS = "/UI/PAGE/customer/product/only-mobiles-transition/promotions",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION = "/UI/PAGE/customer/product/shared-mobiles-transition",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION_BUNDLE = "/UI/PAGE/customer/product/shared-mobiles-transition/bundle",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION_CONFIGURATION = "/UI/PAGE/customer/product/shared-mobiles-transition/configuration",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION_ID_BUNDLE = "/UI/PAGE/customer/product/shared-mobiles-transition/:transitionId/bundle",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION_ORDER = "/UI/PAGE/customer/product/shared-mobiles-transition/order",
	CUSTOMER_PRODUCT_SHARED_MOBILES_TRANSITION_PROMOTIONS = "/UI/PAGE/customer/product/shared-mobiles-transition/promotions",
	CUSTOMER_PRODUCT_TERMINATION = "/UI/PAGE/customer/product/termination",
	CUSTOMER_PRODUCT_TRANSITION = "/UI/PAGE/customer/product/transition",
	CUSTOMER_PRODUCT_TRANSITION_BUNDLE = "/UI/PAGE/customer/product/transition/bundle",
	CUSTOMER_PRODUCT_TRANSITION_CONFIGURATION = "/UI/PAGE/customer/product/transition/configuration",
	CUSTOMER_PRODUCT_TRANSITION_ID_BUNDLE = "/UI/PAGE/customer/product/transition/:transitionId/bundle",
	CUSTOMER_PRODUCT_TRANSITION_ORDER = "/UI/PAGE/customer/product/transition/order",
	CUSTOMER_PRODUCT_TRANSITION_PROMOTIONS = "/UI/PAGE/customer/product/transition/promotions",
	CUSTOMERS = "/UI/PAGE/customers",
	DASBOARD = "/UI/PAGE/dashboard",
	LOGIN = "/UI/PAGE/login",
	PRODUCTS = "/UI/PAGE/products",
	RETAIL = "/UI/PAGE/retail",
	RETAIL_APARTMENTS = "/UI/PAGE/retail/apartments",
	RETAIL_BILL_OPERATIONS = "/UI/PAGE/retail/bill-operations",
	RETAIL_IBAN_VALIDATION = "/UI/PAGE/retail/iban-validation",
	RETAIL_PORTANET = "/UI/PAGE/retail/portanet",
	GENERIC_SALE = "/UI/PAGE/generic-sale",
	SALE = "/UI/PAGE/sale",
	SALE_BUNDLE = "/UI/PAGE/sale/bundle",
	GENERIC_SALE_BUNDLE = "/UI/PAGE/generic-sale/bundle",
	SALE_CONFIGURATION = "/UI/PAGE/sale/configuration",
	GENERIC_SALE_CONFIGURATION = "/UI/PAGE/generic-sale/configuration",
	SALE_CONTRACT = "/UI/PAGE/sale/contract",
	GENERIC_SALE_CONTRACT = "/UI/PAGE/generic-sale/contract",
	SALE_COVERAGE = "/UI/PAGE/sale/coverage",
	GENERIC_SALE_COVERAGE = "/UI/PAGE/generic-sale/coverage",
	SALE_CUSTOMER = "/UI/PAGE/sale/customer",
	GENERIC_SALE_CUSTOMER = "/UI/PAGE/generic-sale/customer",
	SALE_EXTRAS = "/UI/PAGE/sale/extras",
	GENERIC_SALE_EXTRAS = "/UI/PAGE/generic-sale/extras",
	SALE_IDENTIFICATION = "/UI/PAGE/sale/identification",
	GENERIC_SALE_IDENTIFICATION = "/UI/PAGE/generic-sale/identification",
	SALE_PROMOTIONS = "/UI/PAGE/sale/promotions",
	GENERIC_SALE_FEATURES = "/UI/PAGE/generic-sale/features",
	TRACKING_CUSTOMERS_AGGRUPATIONS = "/UI/PAGE/tracking-customers-aggrupations",
	TRACKING_LEADS = "/UI/PAGE/tracking-leads",
	TRACKING_SALES = "/UI/PAGE/tracking-sales"
}
